import { shellCommandSchema, shellCommandResultSchema, type ShellCommandPort } from "@ppt-agent/contracts";

export function createHttpShellCommandPort(): ShellCommandPort {
  let sessionReady: Promise<void> | undefined;
  async function responseBody<T>(response: Response, interruptedMessage: string): Promise<T> {
    const raw = await response.text();
    if (!raw.trim()) throw new Error(interruptedMessage);
    try { return JSON.parse(raw) as T; }
    catch { throw new Error(interruptedMessage); }
  }
  async function ensureSession() {
    sessionReady ??= fetch("/api/session", { credentials: "same-origin", headers: { "X-Flowisle-Client": "web" }, signal: AbortSignal.timeout(10000) })
      .then(async (response) => {
        if (!response.ok) throw new Error("无法建立创作会话，请重试。");
        const body = await responseBody<{ status?: string }>(response, "无法建立创作会话，请重试。");
        if (body.status !== "ok") throw new Error("无法建立创作会话，请重试。");
      }).catch((error: unknown) => { sessionReady = undefined; throw error; });
    await sessionReady;
  }
  return {
    async execute(command) {
      const parsed = shellCommandSchema.parse(command);
      let response: Response;
      try {
        // Establish the HttpOnly cookie before a long request, so polling shares its session.
        await ensureSession();
        response = await fetch("/api/commands", {
          method: "POST", headers: { "Content-Type": "application/json", "X-Flowisle-Client": "web" },
          credentials: "same-origin", signal: AbortSignal.timeout((parsed.type === "inspect_progress" || parsed.type === "read_snapshot") ? 10000 : 3900000), body: JSON.stringify(parsed),
        });
      } catch { throw new Error("无法连接后端或请求超时，请检查服务后重试。"); }
      let body: { status?: string; summary?: string; artifacts?: { result?: unknown } };
      try {
        body = await responseBody(response, "后端连接中断，当前进度已保留。服务恢复后可继续生成。");
      } catch (error) {
        sessionReady = undefined;
        throw error;
      }
      if (!response.ok || body.status !== "ok") throw new Error(body.summary ?? "后端请求失败，请重试。");
      return shellCommandResultSchema.parse(body.artifacts?.result);
    },
  };
}
